export default function SummaryCard({ label, value, isHighlight }) {
  return (
    <div className={`rounded-2xl p-4 border ${isHighlight ? 'bg-brand-600 border-brand-500' : 'bg-white border-gray-200'}`}>
      <div className={`text-xs font-medium mb-1 ${isHighlight ? 'text-white/80' : 'text-gray-500'}`}>{label}</div>
      <div className={`text-xl font-bold tabular-nums ${isHighlight ? 'text-white' : 'text-gray-900'}`}>{value}</div>
    </div>
  );
}
